import React from 'react'
import Link from 'gatsby-link'

const Footer = () => (
  <footer>
    &copy; VisualPerspective 2018
    <span> | </span>
    <Link to="/contact">Contact Us</Link>
  </footer>
)

export default Footer
